module.exports = __webpack_public_path__ + "img/blfgc01_center_003.638d654c.png";